<template>
  <div class="aiVideo">
    <div class="left">
      <ul>
        <li v-for="(device, index) in videoList" :key="index">
          <div @click="setDeviceToBind(device)">{{device.title}}({{device.name}})</div>
        </li>
      </ul>
    </div>
    <div class="center" :class="`videos-${videos.length}`">
      <video-box
        ref="child"
        class="video-preview"
        :class="{ 'is-binding': deviceToBind }"
        v-for="(video, index) in videos"
        :key="index"
        :activated="activatedVideo === video"
        :video="video"
        :accessToken="accessToken"
        :rnd="video.rnd"
        @click.native="deviceToBind ? bindDevices(video) : activeVideo(video)">
      </video-box>
    </div>
    <div class="ai_info">
      <ul class="ai_title">
        <li class="l1">报警时间</li>
        <li class="l2">报警摄像头</li>
        <li class="l3">报警编号</li>
        <li class="l4">报警摘要</li>
        <li class="l5">报警预览</li>
      </ul>
      <div class="ai_con">
        <ul v-for="(item, index) in baojingData" :key="index">
          <li class="l1">{{item.target_begin_time}}</li>
          <li class="l2">{{item.title}}</li>
          <li class="l3">{{item.number}}</li>
          <li class="l4">{{item.target_name}}</li>
        </ul>
        <div class="pic_view"><img :src="baojingData[0].picture" /></div>
      </div>
    </div>
    <div class="right">
      <div class="count-control">
        <div class="count-control-1" @click="createVideos(1)">
          <div></div>
        </div>
        <div class="count-control-4" @click="createVideos(4)">
          <div v-for="i in [1,2,3,4]" :key="i"></div>
        </div>
        <div class="count-control-9" @click="createVideos(9)">
          <div v-for="i in [1,2,3,4,5,6,7,8,9]" :key="i"></div>
        </div>
      </div>
      <video-box-control :accessToken="accessToken" :video="activatedVideo"></video-box-control>
    </div>
  </div>
</template>
<script>
import cameraApi from "@/api/light/camera";
import videoBox from '@/components/video/VideoBox.vue'
import videoBoxControl from '@/components/video/VideoBoxControl.vue'
import { sendWebsocket, closeWebsocket } from '@/utils/websocket.js'
export default {
  components: {
    videoBox,
    videoBoxControl
  },
  data () {
    return {
      accessToken:'',
      videoList: [],
      videos: [],
      deviceToBind: null,
      activatedVideo: {},
      controlSpeed: 50,
      baojingData: [
        {
          alarm_id: 32,
          camera_id: 1,
          created_at: 1624352049,
          number: "810895733",
          picture: "https://light.taiott.com/public/image/1624352049.png",
          ste: 0,
          target_begin_time: "2021-06-22 16:54:09",
          target_name: "离开",
          title: "展厅南一号",
          type: 0
        }
      ],
      path:"wss://light.taiott.com/message",
      websock: null, //建立的连接
      lockReconnect: false, //是否真正建立连接
      timeout: 50 * 1000, //20秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null //断开 重连倒计时
    }
  },
  methods: {
    initWebSocket() {
      //初始化weosocket
      //建立连接
      this.websock = new WebSocket(this.path);
      //连接成功
      this.websock.onopen = this.websocketonopen;
      //连接错误
      this.websock.onerror = this.websocketonerror;
      //接收信息
      this.websock.onmessage = this.websocketonmessage;
      //连接关闭
      this.websock.onclose = this.websocketclose;
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function() {
        //这里发送一个心跳，后端收到后，返回一个心跳消息
        if (self.websock.readyState == 1) {
          //如果连接正常
          self.websock.send('{"cmd":"message.pong"}');
        } else {
          //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function() {
          //超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    websocketonopen() {
      //连接成功事件
      let actions = JSON.stringify({"cmd":"message.index","data":"4"})
      console.log('actions',actions)
      this.websocketsend(actions)
      //提示成功
      console.log("连接成功", 3);
      //开启心跳
      this.start();
    },
    websocketonerror(e) {
      //连接失败事件
      //错误
      console.log("WebSocket连接发生错误");
      //重连
      this.reconnect();
    },
    websocketclose(e) {
      //连接关闭事件
      //提示关闭
      console.log("连接已关闭");
      //重连
      this.reconnect();
    },
    websocketonmessage(event) {
      //接收服务器推送的信息
      let that = this 
      const res = JSON.parse(event.data);
      console.log("res.status",res);
      if(res.status==200){
        if(res.data.data.length>0){
          that.baojingData = res.data.data 
        }
      }
      //收到服务器信息，心跳重置
      that.reset();
    },
    websocketsend(msg) {
      //向服务器发送信息
      this.websock.send(msg);
    },
    getLeftList() {
      cameraApi.cameraList({
        page: 1,
        pageSize: 200,
        type:1
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoList = res.data.data.list;
          this.activatedVideo = res.data.data.list[0]
          this.activatedVideo.index =0
          this.videoGetAccessToken()
          this.createVideos(4)
        }
      });
    },
    createVideos (count) {
      if ([1, 4, 9].indexOf(count) < 0) {
        return
      }
      if (this.activatedVideo && count <= this.activatedVideo.index) {
        this.activatedVideo = {}
      }
      if (count > this.videos.length) {
        for (let i = this.videos.length; i < count; i++) {
          this.videos.push({
            index: i,
            number: 0,//设备序列号
            name: '',
            rnd: Math.random()
          })
        }
      } else if (count < this.videos.length) {
        const videos = []
        for (let i = 0; i < count; i++) {
          videos.push(this.videos[i])
        }
        this.videos = videos
      }
    },
    setDeviceToBind (device) {
      if (this.deviceToBind === device) {
        this.deviceToBind = null
      } else {
        this.deviceToBind = device
        this.activatedVideo = device
        // this.activatedVideo.index =0
      }
    },
    bindDevices (video) {
      video.rnd = Math.random()
      video.number = this.deviceToBind.number//设备序列号
      video.name = this.deviceToBind.name
      this.deviceToBind = null
    },
    activeVideo (video) {
      if (this.activatedVideo === video) {
        this.activatedVideo = null
      } else {
        this.activatedVideo = video
      }
    },
    videoGetAccessToken() {
      cameraApi.getAccessToken().then((res) => {
        this.accessToken = res.data.accessToken;
      });
    }
  },
  created () {
    this.getLeftList()
    this.initWebSocket()
  },
  destroyed() {
    this.websocketclose();//离开路由之后断开websocket连接
  }
}
</script>

<style lang='less' scoped>
.aiVideo{
  .video-container {
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
  }
  .num {
    height: 100%;
    width: 100%;
  }
  .left {
    position: fixed;
    top: 60px;
    left: 0px;
    bottom: 0px;
    width: 180px;
    background: #333;
    color:#fff;
  }
  .left .el-select {
    display: block;
    margin: 15px 0;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .left .el-select + svg {
    display: none;
  }
  .left ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .left ul div {
    line-height:1.4;
    padding: 10px 20px;
    box-sizing: border-box;
    font-size: 14px;
    cursor: pointer;
  }
  .left ul div:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .left > ul {
    font-size: 16px;
    margin: 15px 0;
  }
  .center {
    position: fixed;
    top: 60px;
    left: 180px;
    right: 240px;
    bottom: 220px;
    box-sizing: border-box;
    border:2px solid #ff7c2e
  }
  .right {
    position: fixed;
    top: 60px;
    bottom: 0px;
    right: 0px;
    width: 240px;
    background: #333;
    color: #fff;
  }
  .video-preview-control{
    margin: 0 auto;
  }

  .video-preview-control-main {
      position: relative;
      padding-top: 100%;
      margin-top: 10px;
  }
  .circle {
      position: absolute;
      top: 15px;
      left: 15px;
      right: 15px;
      bottom: 15px;
      border-radius: 50%;
      border: 40px solid #3f475a;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
      background: #1b1b1b;
  }
  .arrow {
      position: absolute;
      cursor: pointer;
      user-select: none;
  }
  .arrow:before {
      content: '';
      display: inline-block;
      position: absolute;
      border: 10px solid #ccdaeb;
      z-index: 1;
  }
  .arrow:hover:before {
      border: 10px solid #fff;
  }
  .arrow:active:before {
      border: 10px solid #666;
  }
  .arrow:after {
      content: '';
      display: inline-block;
      position: absolute;
      border: 10px solid transparent;
      z-index: 0;
  }
  .arrow-up {
      top: -40px;
      left: 0;
      width: 70px;
      height: 40px;
  }
  .arrow-up:before {
      top: 5px;
      left: 25px;
      border-top-color: transparent !important;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
  }
  .arrow-up:after {
      top: 7px;
      left: 27px;
      border-bottom-color: rgba(0, 0, 0, 0.3);
  }
  .arrow-left {
      top: 0;
      left: -40px;
      width: 40px;
      height: 70px;
  }
  .arrow-left:before {
      top: 25px;
      left: 5px;
      border-top-color: transparent !important;
      border-left-color: transparent !important;
      border-bottom-color: transparent !important;
  }
  .arrow-left:after {
      top: 27px;
      left: 7px;
      border-right-color: rgba(0, 0, 0, 0.3);
  }
  .arrow-right {
      top: 0;
      left: 70px;
      width: 40px;
      height: 70px;
  }
  .arrow-right:before {
      top: 25px;
      left: 15px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
  }
  .arrow-right:after {
      top: 27px;
      left: 17px;
      border-left-color: rgba(0, 0, 0, 0.3);
  }
  .arrow-down {
      top: 70px;
      left: 0;
      width: 72px;
      height: 40px;
  }
  .arrow-down:before {
      top: 15px;
      left: 25px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
  }
  .arrow-down:after {
      top: 17px;
      left: 27px;
      border-top-color: rgba(0, 0, 0, 0.3);
  }
  .camera {
      position: absolute;
      background: #cfdff1;
      color: #1b1b1b;
      width: 48px;
      height: 24px;
      line-height: 20px;
      text-align: center;
      left: 11px;
      box-sizing: border-box;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
  }
  .camera-up {
      top: 11px;
      border-top-left-radius: 48px;
      border-top-right-radius: 48px;
      border-bottom: 1px solid #1b1b1b;
  }
  .camera-down {
      bottom: 11px;
      border-bottom-left-radius: 48px;
      border-bottom-right-radius: 48px;
      border-top: 1px solid #1b1b1b;
  }
  .slider {
      overflow: hidden;
  }
  .slider > * {
      float: left;
  }
  .slider > span {
      display: inline-block;
      width: 30px;
      text-align: center;
      height: 36px;
      line-height: 36px;
      vertical-align: top;
  }
  .slider .speed {
      width: 120px;
  }
  .right .count-control {
    border-bottom: 1px solid #696969;
    overflow: hidden;
    text-align: center;
    height: 80px;
  }
  .right .count-control > div {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 20px 5px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #696969;
    background: #23252a;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }
  .right .count-control > div > div {
    float: left;
    border: 1px solid #696969;
    margin: -1px;
  }
  .right .count-control-1 > div {
    width: 36px;
    height: 36px;
  }
  .right .count-control-4 > div {
    width: 18px;
    height: 18px;
  }
  .right .count-control-9 > div {
    width: 12px;
    height: 12px;
  }
  .videos-1 .video-container {
    width: 100%;
    height: 100%;
  }
  .videos-4 .video-container {
    width: 50%;
    height: 50%;
  }
  .videos-9 .video-container {
    width: 33.333333%;
    height: 33.333333%;
  }
  .video-preview.is-binding {
    cursor: pointer;
  }
  .video-preview.is-binding:before {
    content: '在这里显示';
    display: block;
    position: absolute;
    font-size: 24px;
    color: #fff;
    background: #000;
    width: 100%;
    height: 100%;
    text-align: center;
    box-sizing: border-box;
    padding-top: 2em;
    opacity: 0.3;
    z-index: 2;
  }
  .video-preview.is-binding:hover:before {
    opacity: 0.6;
  }
  .right .count-control {
    border-bottom: 1px solid #696969;
    overflow: hidden;
    text-align: center;
    height: 80px;
  }
  .right .count-control > div {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 20px 5px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #696969;
    background: #23252a;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }
  .right .count-control > div > div {
    float: left;
    border: 1px solid #696969;
    margin: -1px;
  }
  .right .count-control-1 > div {
    width: 36px;
    height: 36px;
  }
  .right .count-control-4 > div {
    width: 18px;
    height: 18px;
  }
  .right .count-control-9 > div {
    width: 12px;
    height: 12px;
  }
  .autocomplete-wrapper {
    position: relative;
  }
  .autocomplete-wrapper .el-input input {
    border-radius: 18px;
    padding-right: 35px;
  }
  .autocomplete-search {
    position: absolute;
    top: 10px;
    right: 30px;
    color: #333;
  }
}

.ai_info{
  background: #32373e;
  position: fixed;
  height:220px;
  left: 180px;
  right: 240px;
  bottom: 0;
  ul{
    list-style: none;
    margin:0;
    padding:0;
    li{
      width:180px;
      float: left;
      color:#ff7c2e;
      line-height: 30px;
      font-size: 14px;
      text-align: center;
      font-weight: bold;
    }
  }
  .ai_title{
    background: #333;
    height:30px;
    .l5{
      float: right;
      width:250px;
      text-align: left;
    }
  }
  .ai_con{
    position:relative;
    height:190px;
    padding-top: 5px;
    ul{
      width:100%;
      height: 30px;
      li{
        color:#fff;
        font-size: 12px;
        font-weight: normal;
      }
      &:hover{
        background: #ff7c2e;
        cursor: pointer;
      }
    }
    
  }
  .pic_view{
    position: absolute;
    right:0px;
    top:0;
    img{
      height: 190px;
      width: auto;
    }
  }
}
</style>